import React, { useState, useMemo } from "react";
import Helper from "../helper";
import Select from 'react-select'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import Auth from "../services/auth.service";
import editImg from '../../assets/images/edit.svg';
import thankyouImg from "../../assets/images/Thanks-dc.gif";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import $ from 'jquery';

const SignUp = (props) => {
    const [isEview, setIsEview] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [emailToken, setEmailToken] = useState('');
    const [emailOtp, setEmailOtp] = useState('');
    const idTypeArr = [{ value: 'I', label: 'ID' }, { value: 'P', label: 'Passport' }]
    const [invest1, setInvest1] = useState('');
    const [invest2, setInvest2] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const [idType, setIdType] = useState({ value: 'I', label: 'ID' });
    const [formCounter, setFormCounter] = useState(1);
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [fund, setFund] = useState(0);
    const [input, setInput] = useState({
        "id_type": "I",
        "id_number": "",
        "first_name": "",
        "last_name": "",
        "phone": "",
        "email": ""
    });
    const [emailVerified, setEmailVerified] = useState(false);
    const [open, setOpen] = React.useState(false);

    useMemo(() => {
        if (props.planType !== undefined) {
            setFormCounter(2);
            if (props.planType == 'unit_trust') setFund(2)
            if (props.planType == 'hedge_fund') setFund(1)
            if (props.planType == 'markov_balanced_fund') setFund(3)
            if (props.planType == 'kyrios_global_equity_fund') setFund(4)
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setInput({ ...input, [name]: value });
    }

    const handleEmailChange = e => {
        setEmail(e.target.value)
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (pattern.test(e.target.value)) {
            setIsValid(false)
        } else {
            setIsValid(true)
        }
    }

    const handleChecked = e => {
        const { value, checked } = e.target;

        if (checked) { setFund(value) }
    }

    const handleClose = () => {
        setOpen(false);
    };

    const stepOneSubmitHandler = (e) => {
        e.preventDefault();

        if (!invest1 && !invest2) {
            $('.invest1').show();
            $('.invest2').show();
        } else if (!invest1) {
            $('.invest1').show();
            $('.invest2').hide();
        } else if (!invest2) {
            $('.invest1').hide();
            $('.invest2').show();
        } else {
            setFormCounter(2);
        }
    }

    const handleSendOtp = (name, value, isResend = true) => {
        setOpen(true);
        var formData = new FormData;
        formData.append(name, value ? value : '')
        formData.append('name', (input.first_name || input.last_name) ? `${input.first_name} ${input.last_name}` : '')

        if (name == 'email') sendOtp(formData, setEmailToken, setIsEview, isResend);
    }

    const handleOtpVerify = (name, token, otp) => {
        if (!otp) return Helper.error('The OTP field is required.');
        var formData = new FormData;
        formData.append('token', token)
        formData.append('otp', otp ? otp : '')

        if (name == 'email') tokenVerify(formData, setIsEview, setEmailVerified);
    }

    const sendOtp = (formData, tokenVar, statusVar, isResend) => {
        if (isResend) setIsLoading(true)
        $('.validationAlert').empty();
        $('.input-wrap').removeClass('error');

        Auth.registerSendOtp(formData).then((response) => {
            var res = response.data;
            if (res.success === true) {
                tokenVar(res.data.token)
                statusVar(1);
                Helper.success(res.message);
            } else {
                Helper.validationError(res);
            }
            setIsLoading(false)
        }).catch(err => setIsLoading(false));
    }

    const tokenVerify = (formData, statusVar, verifiedVar) => {
        Auth.registerOtpVerify(formData).then((response) => {
            var res = response.data;
            if (res.success === true) {
                statusVar(2);
                verifiedVar(true);
                $('.validationAlert').empty();
                $('.input-wrap').removeClass('error');
                Helper.success(res.message);
            } else {
                Helper.validationError(res);
            }
        }).catch(err => console.log(err));
    }

    const handleRegister = () => {
        if (!isValidPhoneNumber(phone)) return Helper.error('The phone format is invalid.')
        if (!emailToken) return Helper.error('You need to verify email.')

        setIsSubmit(true);
        var item = input;
        item.email_token = emailToken;
        item.phone = phone;
        item.email = email;
        item.fund = fund ? [fund] : [];
        item.id_type = (idType && idType.value) ? idType.value : '';
        item.is_email_verified = emailVerified
        if (props.planType === undefined) item.invest_for = [invest1, invest2];

        Auth.register(item).then((response) => {
            var res = response.data;
            if (res.success === true) {
                setIsSubmit(false);
                // Helper.success(res.message);
                setFormCounter(3)
            } else {
                Helper.validationError(res);
                setIsSubmit(false);
            }
        }).catch(err => setIsSubmit(false));
    }

    return (
        <section className="">
            <div className="web-signup-container">
                <div className="form-wrapper">
                    {(formCounter === 1) &&
                        <>
                            <div className="register-form-wrap">
                                <div className="form-header">
                                    <h4 className="title">Want To Invest?</h4>
                                    <div className="description">Want to invest, but don’t know which fund is right for you? We’ve created a quick and easy risk assessment tool to steer you in the right direction.</div>
                                </div>
                                <div className="check-option-wrapper">
                                    <div className="check-title">Are you investing for the:</div>
                                    <div>
                                        <label className="container-1 form-check-label" htmlFor="mediumTerm">Medium Term (5-10 years)
                                            <input type="radio" name="invest1" id="mediumTerm" value='Medium Term (5-10 years)' checked={invest1 === 'Medium Term (5-10 years)'} onChange={e => setInvest1(e.target.value)} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div>
                                        <label className="container-1 form-check-label" htmlFor="longTerm">Long Term (Greater than 10 years)
                                            <input type="radio" name="invest1" id="longTerm" value='Long Term (Greater than 10 years)' checked={invest1 === 'Long Term (Greater than 10 years)'} onChange={e => setInvest1(e.target.value)} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="validationAlert invest1" style={{ display: 'none' }}>The field id required.</div>
                                </div>
                                <div className="check-option-wrapper">
                                    <div className="check-title">Tell us about your risk appetite:</div>
                                    <div>
                                        <label className="container-1 form-check-label" htmlFor="investingFor1">I’m comfortable with the volatility of equity markets, but I’m not satisfied with index returns
                                            <input type="radio" name="invest2" id="investingFor1" value='I’m comfortable with the volatility of equity markets, but I’m not satisfied with index returns' checked={invest2 === 'I’m comfortable with the volatility of equity markets, but I’m not satisfied with index returns'} onChange={e => setInvest2(e.target.value)} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div>
                                        <label className="container-1 form-check-label" htmlFor="investingFor2">I want equity-like returns, without the volatility of equity markets
                                            <input type="radio" name="invest2" id="investingFor2" value='I want equity-like returns, without the volatility of equity markets' checked={invest2 === 'I want equity-like returns, without the volatility of equity markets'} onChange={e => setInvest2(e.target.value)} />
                                            <span className="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="validationAlert invest2" style={{ display: 'none' }}>The field id required.</div>
                                </div>
                                <div className="form-footer">
                                    <div className="step-indicator">Step 1 / 2</div>
                                    <div className="button-wrapper">
                                        <button className="btn btn-primary" onClick={stepOneSubmitHandler}>Next</button>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {
                        (formCounter === 2) &&
                        <>
                            <div className="register-form-wrap">
                                <div className="form-header">
                                    {props.planType === undefined && <h4 className="title">Want To Invest?</h4>}
                                    {props.planType !== undefined && props.planType == 'unit_trust' && <h4 className="title">Want To Invest In Unit Trust?</h4>}
                                    {props.planType !== undefined && props.planType == 'hedge_fund' && <h4 className="title">Want To Invest Hedge Fund?</h4>}
                                    {props.planType !== undefined && props.planType == 'markov_balanced_fund' && <h4 className="title">Want To Invest In Markov Balanced Fund?</h4>}
                                    {props.planType !== undefined && props.planType == 'kyrios_global_equity_fund' && <h4 className="title">Want To Invest In Kyrios Global Equity Fund?</h4>}
                                    <div className="description">Want to invest, but don’t know which fund is right for you? We’ve created a quick and easy risk assessment tool to steer you in the right direction.</div>
                                </div>
                                <div className="form-body pb-3">
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label>Your First Name</label>
                                                <div className="input-wrap d-flex">
                                                    <input type="text" className="form-control" name="first_name" value={input.first_name} onChange={handleChange} />
                                                </div>
                                                <div className="validationAlert"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label>Your Last Name</label>
                                                <div className="input-wrap d-flex">
                                                    <input type="text" className="form-control" name="last_name" value={input.last_name} onChange={handleChange} />
                                                </div>
                                                <div className="validationAlert"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label>Your Mobile Number</label>
                                                <div className='input-wrap d-flex'>
                                                    <div className="select-arrow"></div>
                                                    <PhoneInput defaultCountry="ZA" name="phone" value={phone} onChange={setPhone} />
                                                </div>
                                                <div className="validationAlert"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                {isEview == 1 ?
                                                    <>
                                                        <Dialog open={open} className="otp-modal">
                                                            <DialogTitle>Verify Email ID</DialogTitle>
                                                            <DialogContent>
                                                                <DialogContentText>
                                                                    We have sent OTP on <span>{email}</span>
                                                                </DialogContentText>
                                                                <label>Enter Your OTP</label>
                                                                {/* <div className="phone-edit-wrap">
                                                                    <span>{email}</span>
                                                                    <span className="edit-icon pl-2" onClick={e => setIsEview(0)}><img src={editImg} /></span>
                                                                </div> */}
                                                                <div className='input-wrap verfi-input-wrap d-flex'>
                                                                    <input type="text" className="form-control" value={emailOtp} onChange={e => setEmailOtp(e.target.value)} />
                                                                </div>

                                                                <div className="resend-send-btn">
                                                                    <div className="text-muted"><small>Note: Verify OTP to proceed.</small></div>
                                                                    <a className="otp-send" onClick={e => handleSendOtp('email', email, false)}>Resend OTP</a>
                                                                </div>
                                                            </DialogContent>
                                                            <div className="action-modal-sectn">
                                                                <DialogActions className="bottom-action-btn">
                                                                    <Button onClick={handleClose}>Cancel</Button>
                                                                    <a className={emailOtp && emailOtp.length === 6 ? "vrf-btn-bttm" : "vrf-btn-bttm disabled"} onClick={e => handleOtpVerify('email', emailToken, emailOtp)}>Verify</a>
                                                                </DialogActions>
                                                            </div>
                                                        </Dialog>
                                                    </> : null
                                                }
                                                <label>Your Email Address</label>
                                                <div className='input-wrap d-flex'>
                                                    <input type="text" style={{ paddingRight: '110px' }} className={isEview === 2 ? "form-control is-valid" : "form-control"} name="email" value={email} onChange={handleEmailChange} readOnly={isEview === 2} />
                                                    {isEview !== 2 && <div className="otp-send-btn" disabled={isValid ? true : false}>
                                                        <a className={isLoading ? "otp-send btn-loading" : "otp-send"} onClick={e => { handleSendOtp('email', email) }}>Send OTP</a>
                                                    </div>}
                                                </div>
                                                <div className="text-muted"><small>Note: Please verify your email id to proceed .</small></div>
                                                <div className="validationAlert"></div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <label>Your ID Number / Passport Number</label>
                                                <div className="input-wrap d-flex">
                                                    <div className="select-arrow"></div>
                                                    <div className="select-wrapper"> <Select options={idTypeArr} name="id_type" isSearchable={false} value={idType} onChange={setIdType} placeholder={'ID Type'}></Select> </div>
                                                    <input type="text" name="id_number" className="form-control id-number-adj" value={input.id_number} onChange={handleChange} />
                                                </div>
                                                <div className="validationAlert"></div>
                                            </div>
                                        </div>
                                        {props.planType === undefined &&
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label>Select Fund</label>
                                                    <div className="input-wrap d-flex">
                                                        <div className="form-check-alter">
                                                            <div className="form-check mb-0">
                                                                <input type="radio" name='fund' className="form-check-input" id="hedgeFund" value='1' onChange={handleChecked} />
                                                                <label className="form-check-label mb-0" htmlFor="hedgeFund">Hedge Fund</label>
                                                                {invest1 == 'Medium Term (5-10 years)' && invest2 == 'I’m comfortable with the volatility of equity markets, but I’m not satisfied with index returns' && <span className="badge ml-2">Recommended</span>}
                                                            </div>
                                                            <div className="form-check mb-0">
                                                                <input type="radio" name='fund' className="form-check-input" id="unitTrust" value='2' onChange={handleChecked} />
                                                                <label className="form-check-label mb-0" htmlFor="unitTrust">Unit Trust</label>
                                                                {invest1 == 'Medium Term (5-10 years)' && invest2 == 'I’m comfortable with the volatility of equity markets, but I’m not satisfied with index returns' ? '' : <span className="badge ml-2">Recommended</span>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="validationAlert"></div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {isEview !== 2 && <div className="fade-form-wrapper"></div>}
                                <div className={props.planType === undefined ? "form-footer" : "form-footer justify-content-end"}>
                                    {props.planType === undefined && <div className="step-indicator">Step 2 / 2</div>}
                                    <div className="button-wrapper">
                                        {props.planType === undefined && <button className="btn btn-primary-outline mx-2" onClick={e => setFormCounter(1)}>Back</button>}
                                        <button className={isSubmit ? "btn btn-primary mx-2 btn-loading" : 'btn btn-primary mx-2'} onClick={handleRegister} disabled={!emailVerified}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {(formCounter === 3) &&
                        <>
                            <div className="thank-you-wrapper">
                                <div className="head-text pt-2">Thank you</div>
                                <div className="image-wrapper py-4 mb-3">
                                    <img src={thankyouImg} height={250} />
                                </div>
                                <h4>You Are All Set!</h4>
                                <div className="description">We have sent an email on your email address with the details. We will get in touch with you soon! </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </section>
    )
}

export default SignUp;